var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 112,
    viewBox: "0 0 125 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.593 95.4889C127.599 102.432 122.571 111.111 114.57 111.111H10.4284C2.4126 111.111 -2.59217 102.419 1.40566 95.4889L53.4773 5.20508C57.4849 -1.74132 67.5224 -1.72873 71.5228 5.20508L123.593 95.4889ZM62.5 76.8229C56.9868 76.8229 52.5174 81.2923 52.5174 86.8055C52.5174 92.3188 56.9868 96.7882 62.5 96.7882C68.0133 96.7882 72.4827 92.3188 72.4827 86.8055C72.4827 81.2923 68.0133 76.8229 62.5 76.8229ZM53.0224 40.9405L54.6322 70.4544C54.7075 71.8355 55.8494 72.9166 57.2325 72.9166H67.7676C69.1507 72.9166 70.2926 71.8355 70.3679 70.4544L71.9777 40.9405C72.0591 39.4488 70.8714 38.1944 69.3774 38.1944H55.6224C54.1285 38.1944 52.941 39.4488 53.0224 40.9405Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ee007cdca7fd89249e5721bf1cc45051.svg";
export { ForwardRef as ReactComponent };